














































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon } from '../sw-icon';
import { utilService } from '../util-service';
import { CSSStyleOptions } from '../common-types';

const cssPrefix = 'sw-badge';

@Component({
  components: {
    SwIcon,
  },
})
export default class SwBadge extends SwExtendedVue {
  @Prop({ type: [Number, String], default: undefined })
  content: number | string | undefined;

  @Prop({ type: Number, default: 999 })
  cap: number;

  @Prop({ type: String, default: 'top-left' })
  placement: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';

  @Prop({ type: Boolean, default: false })
  dot: boolean;

  @Prop({ type: String, default: utilService.colorConst.statusCritical })
  color: string;

  @Prop({ type: [Boolean, String], default: false })
  inset: boolean | 'half';

  cssPrefix = cssPrefix;

  get badgeTextStyle(): CSSStyleOptions {
    if (this.dot) { return {}; }
    return {
      backgroundColor: this.color,
    };
  }

  get effectiveContent(): string {
    if (this.dot) { return ''; }
    if (typeof this.content === 'number') {
      if (this.content > this.cap) {
        return `${this.cap}+`;
      }
      return String(this.content);
    }
    if (typeof this.content === 'string') {
      return this.content;
    }
    return '';
  }

  get isBottom() {
    return this.placement === 'bottom-left' || this.placement === 'bottom-right';
  }

  get isTop() {
    return this.placement === 'top-left' || this.placement === 'top-right';
  }

  get isLeft() {
    return this.placement === 'top-left' || this.placement === 'bottom-left';
  }

  get isRight() {
    return this.placement === 'top-right' || this.placement === 'bottom-right';
  }
}
